export default __webpack_public_path__ + "static/media/Strips.4f336307.svg";